// Banner di ricerca overlay con ricerca predittiva integrata
document.addEventListener('DOMContentLoaded', function() {
  const searchToggle = document.querySelector('.js-show-search');
  const searchOverlay = document.getElementById('searchOverlay');
  const searchInput = document.getElementById('searchOverlayInput');
  const searchClose = document.getElementById('searchOverlayClose');
  const searchResults = document.getElementById('searchOverlayResults');
  const header = document.querySelector('store-header');
  
  if (!searchToggle || !searchOverlay || !searchInput) return;

  let searchTimeout;
  let currentController;

  // Funzione per ottenere i testi nella lingua corrente
  function getMessages() {
    const isItalian = searchInput.placeholder.includes('Cerca');

    return {
      searching: isItalian ? 'Ricerca in corso...' : 'Searching...',
      noResults: isItalian ? 'Nessun prodotto trovato' : 'No products found',
      error: isItalian ? 'Errore durante la ricerca' : 'Search error',
      noImage: isItalian ? 'Nessuna immagine' : 'No image'
    };
  }

  // Apri overlay
  searchToggle.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (header) {
      header.classList.add('search-is-collapsed');
    }
    
    searchOverlay.classList.add('is-visible');
    searchInput.focus();
    searchInput.click();
  });

  // Chiudi overlay
  function closeOverlay() {
    searchOverlay.classList.remove('is-visible');
    searchInput.value = '';
    searchResults.innerHTML = '';
    
    if (currentController) {
      currentController.abort();
      currentController = null;
    }
    
    if (header) {
      header.classList.add('search-is-collapsed');
    }
  }

  searchClose.addEventListener('click', closeOverlay);
  
  searchOverlay.addEventListener('click', function(e) {
    if (e.target === searchOverlay) {
      closeOverlay();
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay.classList.contains('is-visible')) {
      closeOverlay();
    }
  });

  // RICERCA PREDITTIVA
  searchInput.addEventListener('input', function(e) {
    const query = e.target.value.trim();
    
    clearTimeout(searchTimeout);
    
    if (currentController) {
      currentController.abort();
    }
    
    if (query.length < 1) {
      searchResults.innerHTML = '';
      return;
    }
    
    searchTimeout = setTimeout(() => {
      performSearch(query);
    }, 300);
  });

  // INVIO per andare alla pagina di ricerca completa
  searchInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      const query = e.target.value.trim();
      
      if (query.length > 0) {
        window.location.href = `/search?q=${encodeURIComponent(query)}`;
      }
    }
  });

  // Funzione di ricerca
  async function performSearch(query) {
    try {
      currentController = new AbortController();
      
      const messages = getMessages();
      searchResults.innerHTML = `<div class="search-loading">${messages.searching}</div>`;
      
      const isMobile = window.innerWidth <= 768;
      const limit = isMobile ? 4 : 8;
      
      const searchUrl = `/search?q=${encodeURIComponent(query)}&type=product&options[prefix]=last`;
      
      const response = await fetch(searchUrl, {
        signal: currentController.signal,
        headers: {
          'Accept': 'application/json'
        }
      });
      
      if (!response.ok) {
        return performSuggestSearch(query);
      }
      
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Estrai tutti i link dei prodotti
      const allProductLinks = Array.from(doc.querySelectorAll('a[href*="/products/"]'))
        .filter(link => !link.href.includes('#'));

      // Controlla se l'utente sta cercando specificamente il buono regalo
      const queryLower = query.toLowerCase();
      const isSearchingGiftCard = queryLower.includes('buono') || 
                                  queryLower.includes('gift') || 
                                  queryLower.includes('regalo') || 
                                  queryLower.includes('card');

      // Rimuovi duplicati e buoni regalo (tranne se cercati esplicitamente)
      const seenHandles = new Set();
      const productLinks = allProductLinks.filter(link => {
        const handle = link.href.split('/products/')[1]?.split('?')[0]?.split('#')[0];
        if (!handle || seenHandles.has(handle)) {
          return false;
        }
        // Escludi buoni regalo SOLO se non li stanno cercando
        if (!isSearchingGiftCard && (handle.includes('buono-regalo') || handle.includes('gift-card') || handle.includes('gift_card'))) {
          return false;
        }
        seenHandles.add(handle);
        return true;
      }).slice(0, isMobile ? 3 : 7);

      if (productLinks.length === 0) {
        searchResults.innerHTML = `<div class="no-results">${messages.noResults}</div>`;
        return;
      }
      
      // Costruisci array di prodotti dai link trovati
      const products = productLinks.map(link => {
        const productUrl = link.href;
        const productHandle = productUrl.split('/products/')[1]?.split('?')[0];
        
        return {
          url: productUrl,
          handle: productHandle,
          title: link.textContent.trim() || link.getAttribute('title') || productHandle,
          image: null
        };
      });
      
      // Carica le immagini dei prodotti
      await loadProductImages(products);
      
      displayResults(products);
      
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Errore ricerca:', error);
        return performSuggestSearch(query);
      }
    }
  }

  // Funzione fallback con suggest
  async function performSuggestSearch(query) {
    try {
      const messages = getMessages();
      const isMobile = window.innerWidth <= 768;
      const limit = isMobile ? 3 : 7;
      
      const searchUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${limit}`;
      
      const response = await fetch(searchUrl);
      const data = await response.json();
      let products = data.resources.results.products || [];

      // Controlla se l'utente sta cercando specificamente il buono regalo
      const queryLower = query.toLowerCase();
      const isSearchingGiftCard = queryLower.includes('buono') || 
                                  queryLower.includes('gift') || 
                                  queryLower.includes('regalo') || 
                                  queryLower.includes('card');

      // Escludi i buoni regalo SOLO se non li stanno cercando
      if (!isSearchingGiftCard) {
        products = products.filter(product => {
          const title = (product.title || '').toLowerCase();
          const type = (product.type || '').toLowerCase();
          return type !== 'gift_card' && !title.includes('buono regalo');
        });
      }
      
      if (products.length > 0) {
        displayResults(products);
      } else {
        searchResults.innerHTML = `<div class="no-results">${messages.noResults}</div>`;
      }
    } catch (error) {
      console.error('Errore ricerca suggest:', error);
      const messages = getMessages();
      searchResults.innerHTML = `<div class="search-error">${messages.error}</div>`;
    }
  }

  // Carica le immagini dei prodotti
  async function loadProductImages(products) {
    const promises = products.map(async (product) => {
      try {
        const response = await fetch(`/products/${product.handle}.js`);
        const data = await response.json();
        product.image = data.featured_image;
        product.title = data.title;
      } catch (error) {
        console.log('Impossibile caricare immagine per:', product.handle);
      }
    });
    
    await Promise.all(promises);
  }

  // Visualizza risultati
  function displayResults(products) {
    if (!products || products.length === 0) {
      const messages = getMessages();
      searchResults.innerHTML = `<div class="no-results">${messages.noResults}</div>`;
      return;
    }
    
    const resultsGrid = document.createElement('div');
    resultsGrid.className = 'search-results-grid';
    const messages = getMessages();
    
    products.forEach(product => {
      const resultItem = document.createElement('div');
      resultItem.className = 'search-result-item';
      
      let resultHTML = `<a href="${product.url}" class="search-result-link">`;
      
      if (product.image) {
        resultHTML += `<div class="result-image"><img src="${product.image}" alt="${product.title}" loading="lazy"></div>`;
      } else {
        resultHTML += `<div class="result-image"><div class="placeholder-image">${messages.noImage}</div></div>`;
      }
      
      resultHTML += '<div class="result-info">';
      
      if (product.title) {
        resultHTML += `<div class="result-title">${product.title}</div>`;
      }
      
      resultHTML += '</div></a>';
      
      resultItem.innerHTML = resultHTML;
      resultsGrid.appendChild(resultItem);
    });
    
    // Casella "Tutti i risultati"
    const viewAllItem = document.createElement('div');
    viewAllItem.className = 'search-result-item view-all-item';
    
    const currentQuery = searchInput.value.trim();
    const viewAllText = messages.searching.includes('Ricerca') ? 'Tutti i risultati' : 'All results';
    
    const viewAllHTML = `
      <a href="/search?q=${encodeURIComponent(currentQuery)}" class="search-result-link view-all-link">
        <div class="result-image view-all-image">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
        </div>
        <div class="result-info">
          <div class="result-title view-all-title">${viewAllText}</div>
          <div class="result-subtitle" style="font-size: 0.75em; color: #6c757d; margin-top: 4px; opacity: 0.8;">→</div>
        </div>
      </a>
    `;
    
    viewAllItem.innerHTML = viewAllHTML;
    resultsGrid.appendChild(viewAllItem);
    
    searchResults.innerHTML = '';
    searchResults.appendChild(resultsGrid);
  }

  // Impedisci che la ricerca originale si apra
  document.addEventListener('click', function(e) {
    if (e.target.closest('.js-show-search') && header) {
      header.classList.add('search-is-collapsed');
    }
  });
});